/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_History_MoreInputs */

const en_us2_plan_history_more = /** @type {(inputs: Plan_History_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show more`)
};

const pt_br2_plan_history_more = /** @type {(inputs: Plan_History_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver mais`)
};

const es_419_plan_history_more = /** @type {(inputs: Plan_History_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver más`)
};

const pt_pt2_plan_history_more = /** @type {(inputs: Plan_History_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver mais`)
};

const fr_fr2_plan_history_more = /** @type {(inputs: Plan_History_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir plus`)
};

const de_de2_plan_history_more = /** @type {(inputs: Plan_History_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr anzeigen`)
};

const it_it2_plan_history_more = /** @type {(inputs: Plan_History_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra altro`)
};

/**
* | output |
* | --- |
* | "Show more" |
*
* @param {Plan_History_MoreInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_history_more = /** @type {((inputs?: Plan_History_MoreInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_History_MoreInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_history_more(inputs)
	if (locale === "es-419") return es_419_plan_history_more(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_history_more(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_history_more(inputs)
	if (locale === "de-DE") return de_de2_plan_history_more(inputs)
	if (locale === "it-IT") return it_it2_plan_history_more(inputs)
	return en_us2_plan_history_more(inputs)
});
export { plan_history_more as "plan.history_more" }